// initialize tokenInterval
let tokenInterval;

/**
 * Starts periodic session validation.
 * @param {function} validateSessionFunc - The function to call for validating the session. This function should handle any necessary API calls and state updates related to session validity.  It is typically a function from your state management library (e.g., Zustand, Redux) that accesses and updates the authentication status.
 */
export const startSessionValidation = validateSession => {
  // Initial check
  validateSession();

  tokenInterval = setInterval(validateSession, 5000);
};

/**
 * Stops periodic session validation.  This should be called when the component unmounts or when session validation is no longer required.
 */
export const stopSessionValidation = () => {
  clearInterval(tokenInterval);
};
